(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chittera-scroll-top"] && !Shopify.designMode) return;
  try {
    class ChitteraToTop extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold) || 500;
      this.wrapper = document.querySelector('.page-wrapper');
      this.shown = null;
      this.ticking = false;

      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      };

      // The anchor alone is not enough. The header section is position: sticky,
      // so the browser treats #header-group as already in view and performs no
      // fragment scroll — and above 990px the document does not scroll at all,
      // .page-wrapper does. So drive the scroll directly.
      this.onClick = (event) => {
        event.preventDefault();

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const behavior = reduce ? 'auto' : 'smooth';

        // Only one of these is the live scroll container; the other is a no-op.
        this.wrapper?.scrollTo({ top: 0, behavior });
        window.scrollTo({ top: 0, behavior });

        // This control hides itself once the page returns to the top, which
        // would strand keyboard focus on a hidden element. Hand focus to the
        // top of the document instead, without disturbing the scroll.
        const top = document.getElementById('header-group');
        if (top) {
          top.setAttribute('tabindex', '-1');
          top.focus({ preventScroll: true });
        }
      };

      this.link = this.querySelector('a');
      this.link?.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.wrapper?.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      this.link?.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      this.wrapper?.removeEventListener('scroll', this.onScroll);
    }

    update() {
      // Only one of these is ever non-zero, so the sum is the real offset
      // whichever element is currently scrolling.
      const offset = (this.wrapper?.scrollTop || 0) + window.scrollY;
      const show = offset > this.threshold;
      if (show === this.shown) return;
      this.shown = show;
      this.toggleAttribute('visible', show);
    }
  }

  if (!customElements.get('chittera-to-top')) {
    customElements.define('chittera-to-top', ChitteraToTop);
  }
  } catch(e) { console.error(e); }
})();

})();
